import React from "react";
import "./css/ServicesPage.css";
import roofing from '../images/roofing.jpg'; // Replace with your actual roofing image path
import plumber from '../images/plumber.jpg'; // Replace with your actual plumber image path
import bg from '../images/custom-img-95-copyright.jpg'   
import gallery4 from '../images/gallery4.jpg'; // Replace with your actual gallery image path    
import blog1 from '../images/blog1.jpg'; // Replace with your actual blog image path 
import blog2 from '../images/blog2.jpg'; // Replace with your actual blog image path
import blog3 from '../images/blog3.jpg'; // Replace with your actual blog image path

/* ---------- small icon components (inline SVGs, no deps) ---------- */
const IconToolbox = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true">
    <path d="M7 7V6a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v1h2a2 2 0 0 1 2 2v6H3V9a2 2 0 0 1 2-2h2Zm2-1h6v1H9V6Z" fill="none" stroke="currentColor" strokeWidth="1.8" />
    <path d="M3 15v2a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-2" fill="none" stroke="currentColor" strokeWidth="1.8" />
  </svg>
);

const IconPaint = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true">
    <path d="M3 5h14v6H3zM17 8h4v3a3 3 0 0 1-3 3H8" fill="none" stroke="currentColor" strokeWidth="1.8" />
    <path d="M8 20v-6" fill="none" stroke="currentColor" strokeWidth="1.8" />
  </svg>
);

const IconWrench = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true">
    <path d="M15.5 6.5a4.5 4.5 0 1 1-6.36 6.36L3 19l2 2 6.14-6.14A4.5 4.5 0 0 1 15.5 6.5Z" fill="none" stroke="currentColor" strokeWidth="1.8" />
  </svg>
);

const IconHome = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true">
    <path d="m3 11 9-7 9 7v9a2 2 0 0 1-2 2h-4v-6H9v6H5a2 2 0 0 1-2-2v-9Z" fill="none" stroke="currentColor" strokeWidth="1.8" />
  </svg>
);

const ArrowRight = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
    <path d="M5 12h14M13 6l6 6-6 6" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

/* ---------- demo data (replace with your CMS/content as needed) ---------- */
const SERVICE_CARDS = [
  {
    title: "Renovation",
    text: "Tailored renovation solutions to meet your vision.",
    image: roofing,
    link: "#",
  },
  {
    title: "Planning",
    text: "Our skilled team specializes in delivering quality home repairs.",
    image: plumber,
    link: "#",
  },
  {
    title: "Crafting",
    text: "Beautiful, functional spaces built with care.",
    image: blog2,
    link: "#",
  },
  {
    title: "Improvement",
    text: "Comprehensive solutions for all your renovation needs.",
    image: blog1,
    link: "#",
  },
  {
    title: "Painting",
    text: "Handyman & repair services tailored to your needs.",
    image: blog3,
    link: "#",
  },
  {
    title: "Handyman",
    text: "Top-notch handyman & repair solutions.",
    image: gallery4,
    link: "#",
  },
];

const FEATURE_CARDS = [
  { title: "Handyman services", text: "We elevate your living environment.", icon: <IconToolbox /> },
  { title: "Craft services", text: "We enhance your home experience.", icon: <IconHome /> },
  { title: "Repair services", text: "Experts in repairs & renovations.", icon: <IconWrench /> },
  { title: "Renovation services", text: "We improve home quality & style.", icon: <IconPaint /> },
];

const PROCESS_STEPS = [
  {
    no: "01",
    title: "Consultation",
    text:
      "We provide exceptional gardening services that beautify your outdoor spaces and promote growth.",
    link: "#",
  },
  {
    no: "02",
    title: "Landscape",
    text:
      "Transform your outdoor spaces into beautiful retreats. Our skilled team enhances your landscape.",
    link: "#",
  },
  {
    no: "03",
    title: "Planting",
    text:
      "Dedicated planting services that help your landscape thrive all year round.",
    link: "#",
  },
];

export default function ServicesPage({
  heroLandscape =
    "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?q=80&w=1920&auto=format&fit=crop",
}) {
  return (
    <main className="svc">
      {/* Intro */}
      <header className="svc-header">
        <p className="svc-eyebrow">Enhancing your home with Tasker</p>
        <h1 className="svc-title">Hear from our happy clients</h1>
        <p className="svc-sub">Explore our clients’ testimonials and success stories with Tasker.</p>
      </header>

      {/* 3×2 service grid */}
      <section className="svc-grid">
        {SERVICE_CARDS.map((card, i) => (
          <article className="svc-card" key={i}>
            <div className="svc-card-img">
              <img src={card.image} alt={card.title} loading="lazy" />
            </div>
            <div className="svc-card-body">
              <h3>{card.title}</h3>
              <p>{card.text}</p>
                <a href={card.link} className="svc-card-cta">Learn More</a>
            </div>
          </article>
        ))}
      </section>

      {/* Dark band with features */}
      <section className="svc-band">
        <div className="svc-band-inner">
          <p className="svc-eyebrow svc-eyebrow--light">Enhancing your home experience</p>
          <h2 className="svc-band-title ">We build & improve<br/>your spaces</h2>
          <p className="svc-band-sub">
            Discover our clients and read their testimonials about our work.
          </p>

          <div className="svc-feature-grid">
            {FEATURE_CARDS.map((f, i) => (
              <div className="svc-feature" key={i}>
                <div className="svc-feature-icon">{f.icon}</div>
                <div className="svc-feature-content">
                  <h4>{f.title}</h4>
                  <p>{f.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Process list */}
      <section className="svc-process">
        <div className="svc-process-head">
          <p className="svc-eyebrow">Enhancing your home with gardening</p>
          <h2>Tailored landscaping<br/>for every home</h2>
        </div>

        <ol className="svc-steps">
          {PROCESS_STEPS.map((s, i) => (
            <li className="svc-step" key={i}>
              <div className="svc-step-no">{s.no}</div>
              <div className="svc-step-main">
                <div className="svc-step-title">{s.title}</div>
                <p className="svc-step-text">{s.text}</p>
              </div>
              <button className="svc-step-cta" aria-label={`Learn more about ${s.title}`}>
                <ArrowRight />
              </button>
            </li>
          ))}
        </ol>
      </section>

      {/* Full-bleed landscape image */}
      <figure className="svc-fullbleed">
        <img src={bg} alt="Landscaping work" loading="lazy" />
      </figure>

      {/* <section className="svc-tagline">
        Your trusted partner for all handyman needs and repairs
      </section> */}
    </main>
  );
}
